import { render, staticRenderFns } from "./LocalEntrega.vue?vue&type=template&id=17da3587"
import script from "./LocalEntrega.vue?vue&type=script&lang=js"
export * from "./LocalEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports